import script from "./PCLectorArticuloElaboradoYActividad.vue?vue&type=script&setup=true&lang=js"
export * from "./PCLectorArticuloElaboradoYActividad.vue?vue&type=script&setup=true&lang=js"

import "./PCLectorArticuloElaboradoYActividad.vue?vue&type=style&index=0&id=7a239bb2&lang=scss"

const __exports__ = script;

export default __exports__